import { render } from "./LastUpdated.vue?vue&type=template&id=12cf80af"
import script from "./LastUpdated.vue?vue&type=script&lang=js"
export * from "./LastUpdated.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/mcd-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__